import React from "react";
import { Box, Button } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface GeneratedImageDisplayProps {
  imageUrl: string;
  onUseImage: () => void;
  onUseAsReference: () => void;
}

const GeneratedImageDisplay: React.FC<GeneratedImageDisplayProps> = ({
  imageUrl,
  onUseImage,
  onUseAsReference,
}) => {
  const { t } = useTranslation();

  const handleDownload = () => {
    // Create a temporary anchor element to trigger download
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = `${t("imageGenerator.generatedImageFilename")}-${Date.now()}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box>
      <Box display="flex" justifyContent="center" mb={1}>
        <PreviewImage src={imageUrl} alt={t("imageGenerator.generatedImageAlt")} />
      </Box>
      <Box display="flex" justifyContent="center" flexWrap="wrap">
        <Box mr={1} mb={1}>
          <Button variant="outlined" onClick={handleDownload} startIcon={<GetApp />} size="small">
            {t("imageGenerator.download")}
          </Button>
        </Box>
        <Box mr={1} mb={1}>
          <Button variant="outlined" onClick={onUseAsReference} size="small">
            {t("imageGenerator.useAsReference")}
          </Button>
        </Box>
        <Box mb={1}>
          <Button variant="contained" color="secondary" onClick={onUseImage} size="small">
            {t("imageGenerator.useThisImage")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default GeneratedImageDisplay;

const PreviewImage = styled.img`
  max-height: 480px;
  max-width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
`;
